import http from "../../http-common";
/**
 * Author : AndréK
 * 26/08/2022
*/

//techLead
const createTechLead = (data) => {
    return http.post("/TechLead/InsertTechLead", data);
};

const getTechLead = (data) => {
    return http.post("/TechLead/FilterTechLead", data);
};

const updateTechLead = (data) => {
    return http.post("/TechLead/UpdateTechLead", data);
};

//Address
const createTechLeadAddress = (data) => {
    return http.post("/TechLead/InsertTechLeadAddress", data);
};

const getTechLeadAddress = (data) => {
    return http.post("/TechLead/FilterTechLeadAddress", data);
};

const updateTechLeadAddress = (data) => {
    return http.post("/TechLead/UpdateTechLeadAddress", data);
};

//Email
const createTechLeadEmail = (data) => {
    return http.post("/TechLead/InsertTechLeadEmail", data);
};

const getTechLeadEmail = (data) => {
    return http.post("/TechLead/FilterTechLeadEmail", data);
};

const updateTechLeadEmail = (data) => {
    return http.post("/TechLead/UpdateTechLeadEmail", data);
};

//Phone
const createTechLeadPhone = (data) => {
    return http.post("/TechLead/InsertTechLeadPhone", data);
};

const getTechLeadPhone = (data) => {
    return http.post("/TechLead/FilterTechLeadPhone", data);
};

const updateTechLeadPhone = (data) => {
    return http.post("/TechLead/UpdateTechLeadPhone", data);
};


export default {
    createTechLead,
    getTechLead,
    updateTechLead,
    createTechLeadAddress,
    getTechLeadAddress,
    updateTechLeadAddress,
    createTechLeadEmail,
    getTechLeadEmail,
    updateTechLeadEmail,
    createTechLeadPhone,
    getTechLeadPhone,
    updateTechLeadPhone
};
